import { Edit, Preview, Reserve, Save, Update } from '@containers/reserved-symbol/components/company-button';
import { ButtonProps } from '@mis/sushi-tailwind-react';
import React from 'react';
import { DeleteButton } from '../delete-button/DeleteButton';
import { MiddleDarkButton } from '../middle-dark-button/MiddleDarkButton';
import { PrimaryButton } from '../primary-button/PrimaryButton';
import { SecondaryButton } from '../secondary-button/SecondaryButton';

export interface ListButtonItem extends ButtonProps {
  buttonStyle?: 'PRIMARY' | 'SECONDARY' | 'DELETE' | 'EDIT' | 'PREVIEW' | 'UPDATE' | 'SAVE' | 'RESERVE' | 'MIDDLE_DARK';
}

interface ListButtonProps {
  items: ListButtonItem[];
  baseProps?: ListButtonItem;
}

export const ListButton: React.FC<ListButtonProps> = ({ items, baseProps }) => {
  return (
    <>
      {items.map(({ buttonStyle, ...item }, index) => {
        switch (buttonStyle) {
          case 'PRIMARY':
            return <PrimaryButton key={index} {...baseProps} {...item} />;
          case 'SECONDARY':
            return <SecondaryButton key={index} {...baseProps} {...item} />;
          case 'DELETE':
            return <DeleteButton key={index} {...baseProps} {...item} />;
          case 'EDIT':
            return <Edit key={index} {...baseProps} {...item} />;
          case 'PREVIEW':
            return <Preview key={index} {...baseProps} {...item} />;
          case 'UPDATE':
            return <Update key={index} {...baseProps} {...item} />;
          case 'SAVE':
            return <Save key={index} {...baseProps} {...item} />;
          case 'RESERVE':
            return <Reserve key={index} {...baseProps} {...item} />;
          case 'MIDDLE_DARK':
            return <MiddleDarkButton key={index} {...baseProps} {...item} />;
          default:
            if (index === items.length - 1) {
              return <PrimaryButton key={index} {...baseProps} {...item} />;
            } else {
              return <SecondaryButton key={index} {...baseProps} {...item} />;
            }
        }
      })}
    </>
  );
};

export default ListButton;
